import React from "react";
import _ from "lodash";

import Input from "./Input";
import DeleteRowButton from "./DeleteRowButton";

export default class MultipleInputControl extends React.PureComponent {
  state = {
    focusedI: null,
  };

  removeV(i) {
    const value = this.props.value || [];
    if (i < value.length) {
      const nextValue = [...value];
      nextValue.splice(i, 1);
      this.props.onChange && this.props.onChange(nextValue);
    }
  }

  focusV(i) {
    this.inputRefs[i + 1] && this.inputRefs[i + 1].focus();
    this.setState({ focusedI: i });
    this.props.onBlur && this.props.onBlur();
  }

  handleFocus(i) {
    this.setState({ focusedI: i });
  }

  handleChange(i, newV) {
    const value = this.props.value || [];
    if (i < value.length) {
      if (!newV) {
        this.removeV(i);
      } else {
        const nextValue = [...value];
        nextValue[i] = newV;
        this.props.onChange && this.props.onChange(nextValue);
      }
    } else {
      this.props.onChange && this.props.onChange(value.concat([newV]));
    }
  }

  handleBlur(i) {
    const value = this.props.value || [];
    this.setState({ focusedI: null });
    // if (i < value.length && !value[i]) {
    //   const nextValue = [...value]
    //   nextValue.splice(i, 1)
    //   this.props.onChange(nextValue)
    // }
    this.props.onBlur && this.props.onBlur();
  }

  handleKeyDown(i, event) {
    const value = this.props.value || [];
    if (event.key === "Enter" && !(event.nativeEvent.ctrlKey || event.nativeEvent.metaKey)) {
      const nextValue = [...value];
      nextValue.splice(i + 1, 0, "");
      this.props.onChange && this.props.onChange(nextValue);
      this.focusV(i);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    if (event.key === "Backspace" && !value[i]) {
      this.removeV(i);
      this.focusV(i > 0 ? i - 2 : 0);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }

  handlePaste(i, event) {
    if (!event.clipboardData || event.clipboardData.getData("Text").indexOf("\n") === -1) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const nextValue = [...(this.props.value || [])];
    const v = nextValue[i] || "";
    const element = event.target;
    const pastedData = event.clipboardData.getData("Text");
    const pastedLines = pastedData.split("\n");
    const stringBeforeSelection = v.substr(0, element.selectionStart);
    const stringAfterSelection = v.substr(element.selectionEnd, v.length);
    nextValue[i] = stringBeforeSelection.concat(pastedLines[0]);
    let j = i;
    pastedLines.forEach((line, n) => {
      if (n > 0) {
        nextValue.splice(++j, 0, line);
      }
    });
    if (stringAfterSelection) {
      nextValue.splice(++j, 0, stringAfterSelection);
    }
    this.focusV(j);
    this.props.onChange && this.props.onChange(nextValue);
    return false;
  }

  render() {
    const { placeholder, readOnly, disabled, ...rest } = this.props;
    const value = this.props.value || [];
    this.inputRefs = this.inputRefs || [];

    return (
      <div className="MultipleInputControl">
        {value.concat([""]).map((v, i) => (
          <div className="u-positionRelative" key={i}>
            <Input
              {...rest}
              name={i === 0 ? this.props.name : undefined}
              value={v}
              onFocus={this.handleFocus.bind(this, i)}
              onBlur={this.handleBlur.bind(this, i)}
              onChange={this.handleChange.bind(this, i)}
              onKeyDown={this.handleKeyDown.bind(this, i)}
              onPaste={this.handlePaste.bind(this, i)}
              inputRef={(ref) => (this.inputRefs[i] = ref)}
              autoFocus={this.state.focusedI === i}
              inputClassName="u-paddingRight"
              placeholder={i === 0 ? placeholder : I18n.t("papp.components.MultipleInputFormControl.placeholder")}
              readOnly={readOnly}
              disabled={disabled}
            />
            {i < value.length && !(readOnly || disabled) && <DeleteRowButton onClick={this.removeV.bind(this, i)} />}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/MultipleInput.jsx